import { HttpRequestService } from './../../shared/services/http-request.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TopToolbarService {

  constructor(private httpRes: HttpRequestService) { }

  getNotReadedNotification(userId) {
    return  this.httpRes.GetRequest('Notification/GetTopTen/' + userId).toPromise();
  }
  updateNotificationReaded(userId) {
    return  this.httpRes.postRequest('Notification/UpdateToReaded/' , userId).toPromise();
  }

}
